import { useEffect, useState } from "react";
import { Col, Row } from "antd";
import { FormBox, InputBox } from "../../../../../components/AntdAddons";
import { rules } from "./rules";
import { fetchIndustryList } from "../../../Industry/utils/slice";
import { useAppDispatch } from "../../../../../utils/hooks/hooks";
import React from "react";

/**
 * Renders a form component for adding or editing a record in the Certifications module.
 *
 * @param {object} props - The component props.
 * @param {object} props.form - The form instance.
 * @param {string} props.id - The form ID.
 * @param {function} props.handleSubmit - The function to handle form submission.
 * @param {function} props.onValuesChange - The function to handle form value changes and update the form fields.
 * @param {object} props.editValues - The values to edit in the form fields, if value already exists.
 * @return {JSX.Element} The rendered form component.
 */
const FormComponent: React.FC<any> = ({
  form,
  id,
  handleSubmit,
  onValuesChange,
  editValues,
}) => {

  const [industryList, setIndustryList] = useState<any>([]);

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (editValues) {
      const industries = editValues.industries.length > 0 ? editValues.industries.map((item: any) => item.id) : [];

      form.setFieldsValue({ ...editValues, ...{ industries: industries } });
    }
    dispatch(fetchIndustryList())
      .then((data: any) => {
        setIndustryList(data.rows);
      })
      .catch((error: any) => error);
  }, [editValues, form]);

  /**
   * Process the form data and handle the form submission.
   */
  const onFinish = (data: any) => {
    if (data.description !== String(data.description)) {
      data.description = data?.description?.level?.content;
    }
    handleSubmit(data);
  };

  return (
    <>
      <FormBox
        form={form}
        id={id}
        onFinish={onFinish}
        onValuesChange={onValuesChange}
      >
        <Row gutter={15}>
          <Col xs={{ span: 24 }} md={{ span: 24 }}>
            <InputBox.Text
              required
              name="short_form"
              label="Short Form"
              rules={rules.short_form()}
            />
          </Col>
          <Col xs={{ span: 24 }} md={{ span: 24 }}>
            <InputBox.Select
              mode="multiple"
              required
              label="Industries"
              name="industries"
              showSearch
              className="multiSelect"
              optionFilterProp="children"
              filterOption={(input, option: any) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                0
              }
              options={{
                list: industryList,
                valueKey: "id",
                textKey: "industry_name",
              }}
            />
          </Col>
          <Col xs={{ span: 24 }} md={{ span: 24 }}>
            <InputBox.Text
              required
              name="acronym"
              label="Long Form"
              rules={rules.acronym()}
            />
          </Col>
          <Col xs={{ span: 24 }} md={{ span: 24 }} xxl={{ span: 24 }}>
            <InputBox.Editor
              name="description"
              label="Description"
              initValue={form.getFieldValue("description")}
              editorChange={(e: any) => {
                form.setFieldsValue({ description: e });
                onValuesChange();
              }}
            />

          </Col>
        </Row>
      </FormBox>
    </>
  );
};

export default FormComponent;
